import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu\"><path fill=\"#e6e6e6\" d=\"M64 64h896v128H64V64z m0 768h896v128H64v-128z m0-384h896v128H64V448z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol